export default __webpack_public_path__ + "static/media/Gurdeep_Singh_Resume.57304ea2.pdf";